import React from 'react';
import dragIIcon from '../../../assets/images/drag-icon.svg';
import cursorPointer from '../../../assets/images/cursor.svg';
import styles from './DragTitle.module.scss';

const DragTitle = ({ text }) => {
  return (
    <div className={styles.dragDropHeader}>
      <img src={dragIIcon} alt="Drag Icon" />
      <img className={styles.cursorPointer} src={cursorPointer} alt="Cursor" />
      <span>{text}</span>
    </div>
  );
};

export default DragTitle;
